import { useState } from 'react';

const useClientPaginationModel = () => {
  const [clientPaginationModel, setClientPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });

  return {
    clientPaginationModel,
    setClientPaginationModel,
  };
};

export default useClientPaginationModel;
